// Master-P3 Wave 1.2 — Guided Integration Center.
//
// This component preserves the existing `Integrations` CRM gallery at
// the same route (`/app/integrations`) by rendering it as the first
// tab. The new "KI-Anbieter" (BYO-LLM) tab is the Wave 1 scope; the
// remaining tabs are labelled placeholders for later waves.
import React from "react";
import Integrations from "./Integrations";
import LLMProvidersTab from "./LLMProvidersTab";
import AdChannelsTab from "./AdChannelsTab";
import ResearchProvidersTab from "./ResearchProvidersTab";
import OperatorTab from "./OperatorTab";
import { Tabs, TabsContent, TabsList, TabsTrigger }
  from "../../components/ui/tabs";
import { Card, CardContent } from "../../components/ui/card";
import { Sparkles } from "lucide-react";

function ComingSoonTab({ label, wave }) {
  return (
    <Card data-testid={`gic-coming-soon-${label.toLowerCase()}`}>
      <CardContent className="flex flex-col items-center justify-center
                                   text-center gap-3 py-16">
        <Sparkles className="h-8 w-8 text-muted-foreground" />
        <div className="text-lg font-semibold">{label}</div>
        <p className="text-sm text-muted-foreground max-w-md">
          Verfügbar in Wave {wave}. Diese Sektion ist als Platzhalter
          angelegt; die Route und die Test-IDs bleiben stabil, sobald
          die Wave dispatched wird.
        </p>
      </CardContent>
    </Card>
  );
}

export default function GuidedIntegrationCenter() {
  return (
    <div data-testid="guided-integration-center"
          className="space-y-6 p-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">
          Integrationen
        </h1>
        <p className="text-sm text-muted-foreground mt-1 max-w-2xl">
          Verbinde KI-Anbieter, Werbekanäle und Recherche-Zugänge.
          Betreiber-Konfiguration liegt im Betreiber-Bereich.
        </p>
      </div>

      <Tabs defaultValue="llm-providers" className="space-y-6">
        <TabsList className="grid w-full grid-cols-2 sm:grid-cols-5">
          <TabsTrigger value="llm-providers"
                         data-testid="gic-tab-llm-providers">
            KI-Anbieter
          </TabsTrigger>
          <TabsTrigger value="crm"
                         data-testid="gic-tab-crm">
            CRM-Konnektoren
          </TabsTrigger>
          <TabsTrigger value="ad-channels"
                         data-testid="gic-tab-ad-channels">
            Werbekanäle
          </TabsTrigger>
          <TabsTrigger value="research"
                         data-testid="gic-tab-research">
            Recherche-Zugänge
          </TabsTrigger>
          <TabsTrigger value="operator"
                         data-testid="gic-tab-operator">
            Betreiber-Bereich
          </TabsTrigger>
        </TabsList>

        <TabsContent value="llm-providers"
                        data-testid="gic-panel-llm-providers">
          <LLMProvidersTab />
        </TabsContent>
        <TabsContent value="crm" data-testid="gic-panel-crm">
          <Integrations />
        </TabsContent>
        <TabsContent value="ad-channels"
                        data-testid="gic-panel-ad-channels">
          <AdChannelsTab />
        </TabsContent>
        <TabsContent value="research" data-testid="gic-panel-research">
          <ResearchProvidersTab />
        </TabsContent>
        <TabsContent value="operator" data-testid="gic-panel-operator">
          <OperatorTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
